<template>
  <div id="quiz-dashboard">
    <div
      class="d-flex justify-content-between align-items-center mb-2 pl-2 mt-2"
    >
      <div class="d-flex flex-column">
        <div
          class="name-dasboard text-black"
          v-safe-html="dynamicDashboard.name"
        ></div>
        <div class="desc-dashboard" v-safe-html="dynamicDashboard.desc"></div>
      </div>
      <div class="d-flex flex-column align-items-end">
        <div class="underline-link font-medium-4" @click="onOpenExportModal">
          ดูคำตอบเพิ่มเติม
        </div>
        <div class="description font-medium-3">
          *ดาวน์โหลด Report เพื่อดูเพิ่มเติม
        </div>
      </div>
    </div>
    <globalDashboard
      :dashboardLayout="dynamicDashboard.structure"
    ></globalDashboard>

    <history-report-modal
      v-if="modalPopup.report"
      @onCloseModal="closeReportModal"
      :moduleTypeKey="defaultReportFilterType.module"
      :moduleKey="defaultReport.quiz_dashboard"
      :GroupId="dynamicDashboard.Quiz_GroupId"
    />
  </div>
</template>

<script>
import globalDashboard from "@/views/components/dashboard/GlobalDashboard";
import DashboardSvg from "@core/components/svg/common/DashboradSvg.vue";
import useQuizDashboard from "../quiz-list/hooks/useQuizDashboard";
import ExportButton from "@/views/components/button/ExportButton.vue";
import HistoryReportModal from "@/views/pages/report/history-report/HistoryReportModal.vue";

import {
  defaultReport,
  defaultReportFilterType,
  defaultReportCategory,
} from "@/configs/dynamic-config/dynamic-report";

export default {
  components: {
    globalDashboard,
    DashboardSvg,
    ExportButton,
    HistoryReportModal,
  },
  setup() {
    const {
      dynamicDashboard,
      modalPopup,
      onOpenExportModal,
      closeReportModal,
    } = useQuizDashboard();

    return {
      dynamicDashboard,
      modalPopup,
      onOpenExportModal,
      closeReportModal,

      defaultReport,
      defaultReportFilterType,
      defaultReportCategory,
    };
  },
};
</script>

<style scoped>
#quiz-dashboard .underline-link {
  text-decoration: underline;
  color: #007fff;
  cursor: pointer;
  font-weight: bold;
}

#quiz-dashboard .description {
  color: #a2a2a2;
}

#quiz-dashboard .icon-dashboarad {
  width: 25px !important;
  height: 25px !important;
  margin-bottom: 10px;
}

#quiz-dashboard .name-dasboard {
  font-size: 32px;
}

#quiz-dashboard .desc-dashboard {
  font-size: 22px;
}
</style>
